'use strict'

angular.module('shiftTraderApp')
    .controller('AvailabilityManagementCtrl', function($scope, AvailabilityRules, TimeService,
                                                       $state, $stateParams, $location, $uibModal,
                                                       SAErrorHandler, me, org,
                                                       allMedUsers, availability_change_requests,
                                                       UserPermissionsService) {
      $scope.me = me
      $scope.org = org

      $scope.availabilityChangeRequests = availability_change_requests

      $scope.active_acr = _.find($scope.availabilityChangeRequests, function(acr) {
        return !acr.$isExpired()
      })

      $scope.allDepartments = _.map($scope.org.departments, function(dept) {
        dept._selected = true
        return dept
      })

      $scope.allMedUsers = _.sortBy(_.map(_.where(allMedUsers, function(u) {
        return u.$curMemb().active === 1
      }), function(u) {
        u._filteredDayOffCount = 0
        return u
      }), 'first_name')

      $scope.nowDate = TimeService.getNowInStoreTime()
      $scope.currentDate = TimeService.getBeginningOfDayFromDate(moment.utc($stateParams.date)).startOf('month')

      $scope.state = {
        derivedPermissions: null
      }

      var permissionsToLookUp = [
        'availability_sets.edit_policy'
      ]

      UserPermissionsService.getCanDict(permissionsToLookUp, $scope.org.id)
        .then(function(dikt) {
          $scope.state.derivedPermissions = {
            canEditAvailabilityPolicy: dikt['availability_sets.edit_policy']
          }
        })

      $scope.openPolicyModal = function() {
        var modalInstance = $uibModal.open({
          size: 'policy',
          templateUrl: 'views/availabilityPolicyModal.html',
          controller: 'availabilityPolicyModal',
          controllerAs: 'availabilityPolicyModal',
          resolve: {
            params: function() {
              return {
                org: $scope.org,
                canEdit: $scope.state.derivedPermissions.canEditAvailabilityPolicy
              }
            }
          }
        }).result.then(function(orgConfig) {
          $scope.org.organization_config = orgConfig
        })
      }

    })
